import { useEffect, useState } from "react";
import VedicLogo from "../Assets/FPS_Logo.png";
import "../CSS/SplashScreen.css";

import MenuBookIcon from "@mui/icons-material/MenuBook";
import SchoolIcon from "@mui/icons-material/School";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PsychologyIcon from "@mui/icons-material/Psychology";

const fullText = "FATEHPUR PUBLIC SCHOOL";

export default function SplashScreen() {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayText(fullText.slice(0, index + 1));
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, 70);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="splash-root">
      <div className="splash-bg" />

      <MenuBookIcon className="float-icon icon-book" />
      <SchoolIcon className="float-icon icon-cap" />
      <AutoAwesomeIcon className="float-icon icon-star" />
      <PsychologyIcon className="float-icon icon-brain" />

      <div className="splash-content">
        <div className="logo-wrapper">
          <div className="glow-ring"></div>

          <img src={VedicLogo} alt="Fatehpur Public School" className="splash-logo"/>
        </div>


        <h1 className="splash-title typing scholarVarsity">
          {displayText}
          <span className="cursor">|</span>
        </h1>

        <p className="splash-tagline">Knowledge Is Power.</p>
      </div>
    </div>
  );
}
